import { createFileRoute, redirect } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, FeatureFlag } from '@mews-commander/enums';
import { CustomerPaymentsTab, PaymentsTabActiveSegment } from '@mews-commander/modules/src/modules/payment';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => (
    <CustomerPaymentsTab accountId={Route.useParams().accountId} activeSegment={PaymentsTabActiveSegment.Plans} />
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Payment/Plans/$accountId/')({
    component: Component,
    beforeLoad: ({ params: { currentEnterpriseId, accountId }, context: { checkFeatureFlag, featureFlagService } }) => {
        checkFeatureFlag(FeatureFlag.paymentPlanEnabled);

        const isNewCustomerPaymentTabRoutesEnabled = featureFlagService.hasFlag(
            FeatureFlag.newCustomerPaymentTabRoutesEnabled
        );
        const isNewCustomerPageRouteStructureEnabled = featureFlagService.hasFlag(
            FeatureFlag.newCustomerPageRouteStructureEnabled
        );

        if (isNewCustomerPageRouteStructureEnabled) {
            throw redirect({
                to: '/$currentEnterpriseId/Customer/$id/Payment/$activeSegment',
                params: { currentEnterpriseId, id: accountId, activeSegment: PaymentsTabActiveSegment.Plans },
            });
        }
        if (isNewCustomerPaymentTabRoutesEnabled) {
            throw redirect({
                to: '/$currentEnterpriseId/Payment/Plans/$accountId',
                params: { currentEnterpriseId, accountId },
            });
        }
        throw redirect({
            to: '/$currentEnterpriseId/Payment/Index/$accountId',
            params: { currentEnterpriseId, accountId },
            search: { activeSegment: PaymentsTabActiveSegment.Plans },
        });
    },
    staticData: {
        owner: MewsTeam.PaymentExperience,
        type: RouteType.Frontend,
        guideLink: createGuideLink(ArticlePath.TakePayment),
    },
});
